// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3MFIr","notes":"Notes_notes__2xh6-"};